import { useTranslation } from "react-i18next";
import processDone from "shared/assets/icons/process_nocomplete.svg";
import Container from "shared/components/Container";
import { NAME_SPACES } from "shared/locales/constants";
import format from "string-template";
import { getRadianceCosaProduct } from "../constants";

const View = ({ onBack, isAuraTer = false }) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const TRANSLATION = t("DETAIL", { returnObjects: true });
  const { name: productName } = getRadianceCosaProduct(isAuraTer);

  return (
    <Container size="medium">
      <div className="b2c__area contact-us">
        <div className="b2c__area--header">
          <div className="b2c__area--header--icon">
            <img alt="done" src={processDone} />
          </div>
          <h2 className="b2c__area--header__title">
            {TRANSLATION.CASAE_TER.CONTACT_US.THANKS}
          </h2>
          <h3 className="b2c__area--header__desc">
            {format(TRANSLATION.CASAE_TER.CONTACT_US.NO_SUBSCRIPTION, {
              product: productName,
            })}
          </h3>
        </div>

        <div className="contact-us__link" onClick={onBack}>
          {TRANSLATION.CASAE_TER.CONTACT_US.LINK}
        </div>
      </div>
    </Container>
  );
};

export default View;
